module.exports = __webpack_public_path__ + "static/leviathan-cbe011fdb216cd3782cdbc93b0ef51f7.png";